import { ListCreditPoolsResponseSchema, type ListCreditPoolsResponse } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomBaseUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useCreditPoolsList(
  customerId: string,
  options?: CustomBaseUseQueryOptions<ListCreditPoolsResponse>,
) {
  return useQuery(
    queryKeys.creditPools(customerId),
    async () => {
      const api = getPrivateApi();
      const getCreditPoolsListResponse = await api.listCreditPools({ customerId });

      return ListCreditPoolsResponseSchema.parse(getCreditPoolsListResponse);
    },
    { suspense: true, ...options },
  );
}
